"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAvatar = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledAvatar = styled_components_1.default.div `
  align-items: center;
  background: ${config_1.colors.thundercloud};
  border-radius: 50%;
  display: flex;
  height: 40px;
  justify-content: center;
  width: 40px;
`;
